import type { FC } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { GridErrorBoundaryFallback } from 'components/common';
import CreativeTextForm from './CreativeTextForm';

const AddCreativeText: FC = () => {
  return (
    <ErrorBoundary FallbackComponent={GridErrorBoundaryFallback}>
      <CreativeTextForm />
    </ErrorBoundary>
  );
};

export default AddCreativeText;